import { render, staticRenderFns } from "./TaxList.vue?vue&type=template&id=e4903652"
import script from "./TaxList.vue?vue&type=script&lang=js"
export * from "./TaxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports